var MobilePlayerPage =  function() {
    function initTeamSeasonToggle() {
        $('#season_selector').on('change', function() {
            const splitId = this.value.split('-');
            MobilePlayerPage.activeTeam = splitId[2];
            MobilePlayerPage.activeSeason = `${splitId[0]}/${splitId[1]}`;
            loadLeagueData();
        });
    };

    function initLeagueSelector() {
        $('#league_selector > li > a').on('click', function() {
            loadLeagueData($(this).attr('data-league-id'));
        });
    };

    // Track stats click
    function initActionTracker() {
        $('#pill-player-02').on('click', function() {
            ActionTracker.record('playerpage-tab-' + $(this).data('tabname') + '-mobile');
        });
    }

    function loadLeagueData(leagueId = 0) {
        Ajax.getPlayerData(
            MobilePlayerPage.playerId,
            MobilePlayerPage.activeSeason,
            MobilePlayerPage.activeTeam,
            leagueId,
            (res) => {
                if (res.leagues_options) {
                    replaceLeaguesOptions(res.leagues_options);
                    initLeagueSelector();
                }
                if (res.table_html) {
                    replaceMatchesTable(res.table_html, res.hide_more);
                }
                if (res.team_stats_table_html) {
                    replaceTeamStatsTable(res.team_stats_table_html);
                    // initTeamSeasonToggle();
                }
                if (res.has_leagues) {
                    $('#match_data_container').show();
                } else {
                    $('#match_data_container').hide();
                }
            }
        );
    };

    function replaceLeaguesOptions(newOptions) {
        const select = $('#league_selector');
        $('#statsDropdown').text(`${(newOptions.selected ? `Διοργάνωση: ${newOptions.selected}` : '')}`);
        select.empty();
        select.append(newOptions.html);
    }

    function replaceMatchesTable(html) {
        $('#player-matches-table > tbody').remove();
        $('#player-matches-table').append(html);
    }

    function replaceTeamStatsTable(html) {
        $('#team-stats-table').html(html);
    }

    return {
        init: function(playerId, teamId, season) {
            MobilePlayerPage.activeTeam = teamId;
            MobilePlayerPage.playerId = playerId;
            MobilePlayerPage.activeSeason = season;
            // $(`table.player-table tr td input#${PlayerPage.activeTeam}`).prop('checked', true);
            $('.table--check tbody tr').on('click', function() {
            });
            initTeamSeasonToggle();
            initLeagueSelector();
            initActionTracker();
        }
    };
}();
